import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/blogger': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1 0.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4 0.1-29.5-0.2-31.5-0.8-10.3-2.9-14.1-17.7-6.6-25.3zM223.8 290.5c55.4 0 55.1 0 60.4 4.7 7.4 7 5.9 19.3-3.1 24.4l-9.2 1.5-47.9 0.6c-42.2 0.5-54.1-0.2-56.3-1.2-4.4-1.9-8.5-7.3-9.2-12-0.6-4.5 1.6-10.8 5.1-13.9 4.4-3.9 6.3-4.1 60.2-4.1zM447.2 420.6c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-0.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22-1.8-6.7-1.9-9.4-1.9-173.4 0-163.1 0-166.6 1.8-173.7 6.3-24.7 25.9-43.6 51.2-49.2 7.3-1.6 332.1-1.9 340-0.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6 0.2 115.8 0 164.5-0.7 170.5zM361.8 235.4c-1.1-5-4.2-9.6-7.7-11.5-1.1-0.6-8-1.3-15.5-1.7-12.4-0.6-13.8-0.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-0.5-52.5 0.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-0.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7 0.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/blogger.js
// module id = 734
// module chunks = 0